import { motion } from "framer-motion";
import { EASE, IMG } from "@/lib/site";
import { CtaButton } from "@/components/site/CtaButton";
import { Eyebrow } from "@/components/site/Reveal";

const LINES = [["Strong flow.", false], ["Deep sleep.", true], ["Feel like you.", false]];

export const ProstaHero = () => (
  <section id="top" className="relative overflow-hidden bg-[#071E33] pb-32 pt-32 sm:pt-40 lg:min-h-screen" data-testid="prosta-hero-section">
    <div className="grain" />
    <div className="absolute -right-40 top-20 h-[520px] w-[520px] rounded-full bg-[#00AEEF]/15 blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Eyebrow className="!text-[#00AEEF]">Gobbloo Review — No. 02 · Men's health</Eyebrow>
        <h1 className="mt-6 font-display text-[2.4rem] font-bold leading-[1] tracking-tight text-[#F2EDE4] sm:text-6xl lg:text-[4.6rem] xl:text-[5.2rem]" data-testid="prosta-hero-headline">
          {LINES.map(([t, it], i) => (
            <span key={t} className="block overflow-hidden pb-[0.08em]">
              <motion.span className={`block ${it ? "font-serif text-[1.2em] leading-[0.9] italic font-normal text-[#00AEEF]" : ""}`}
                initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.2, ease: EASE, delay: 0.35 + i * 0.14 }}>
                {t}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 1, ease: EASE }}
          className="mt-8 max-w-lg text-base leading-relaxed text-[#F2EDE4]/75 sm:text-lg">
          Our look at <span className="text-[#F2EDE4]">ProstaVive</span> — a daily drink mix (one scoop, one glass a day) with nutrients the maker says
          support prostate blood flow, healthy urine flow, sleep and energy.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.05, duration: 1, ease: EASE }}
          className="mt-10 flex flex-wrap items-center gap-4">
          <CtaButton testId="prosta-hero-hoplink-button" placement="hero" product="prostavive" variant="sky">See today's price</CtaButton>
          <a href="#ingredients" data-testid="prosta-hero-learn-more" className="text-sm text-[#F2EDE4]/75 underline-offset-4 hover:text-[#F2EDE4] hover:underline">What's inside</a>
        </motion.div>
      </div>
      <motion.div className="relative mx-auto w-full max-w-md lg:col-span-5"
        initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, ease: EASE, delay: 0.5 }}>
        <div className="aspect-[4/5] overflow-hidden rounded-[2rem] [clip-path:polygon(0_0,100%_0,100%_100%,18%_100%,0_86%)]">
          <img src={IMG.prostaHero} alt="Confident middle-aged man by the water" className="h-full w-full object-cover" />
        </div>
        <motion.img src="/prostavive-jars.webp" alt="Three jars of ProstaVive" data-testid="prosta-hero-jars"
          animate={{ y: [0, -10, 0] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="absolute inset-x-0 -bottom-10 mx-auto w-[96%] drop-shadow-[0_30px_40px_rgba(0,0,0,0.6)] lg:-left-16" />
      </motion.div>
    </div>
  </section>
);
